export const POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME = {
  ALL: 'all',
  POSITION_NAME: 'position_name',
  JOB_GRADE: 'job_grade',
  POSITION_ID: 'position_code',
  DEPARTMENT: 'department',
  SECTOR: 'sector',
  DIVISION: 'division',
  OPU: 'opu',
  BUSINESS: 'business',
  CURRENT_INCUMBENT: 'current_incument',
};

export const POSITION_MOBILITY_PLAN_DETAIL_SELECT_OPTIONS = [
  { label: 'All', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.ALL },
  { label: 'Position Name', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.POSITION_NAME },
  { label: 'Job Grade', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.JOB_GRADE },
  { label: 'Position ID', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.POSITION_ID },
  { label: 'Department', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.DEPARTMENT },
  { label: 'Sector', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.SECTOR },
  { label: 'Division', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.DIVISION },
  { label: 'OPU', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.OPU },
  { label: 'Business', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.BUSINESS },
  { label: 'Current Incumbent', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.CURRENT_INCUMBENT },
];

export const POSITION_MOBILITY_PLAN_DETAIL_DEFAULT_SELECT_OPTIONS = [
  { label: 'Position Name', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.POSITION_NAME },
  { label: 'Job Grade', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.JOB_GRADE },
  { label: 'OPU', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.OPU },
  { label: 'Business', value: POSITION_MOBILITY_PLAN_DETAIL_SECTION_NAME.BUSINESS },
];
